export const PROPERTY_VIEW_MODE = {
  GRID: 'grid',
  LIST: 'list',
} as const

export type PropertyViewMode = (typeof PROPERTY_VIEW_MODE)[keyof typeof PROPERTY_VIEW_MODE]

// Below this width the list (table) view has no room, so the page always
// shows cards and hides the toggle (ux-principles §6: no tables on mobile).
export const LIST_VIEW_MIN_WIDTH_PX = 992
